module.exports = __webpack_public_path__ + "img/twitch.a4028bcc.svg";